import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Announcement } from "../../shared/interfaces/GameLogicTypes";
import CommunityApi from "../../shared/api/CommunityApi";

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [dismissed, setDismissed] = useState<Set<number>>(new Set());

  useEffect(() => {
    const stored = sessionStorage.getItem("dismissedAnnouncements");
    if (stored) {
      try { setDismissed(new Set(JSON.parse(stored))); } catch {}
    }
    CommunityApi.getAnnouncements().then((a) => setAnnouncements(a));
  }, []);

  const handleDismiss = (id: number) => {
    const next = new Set(dismissed);
    next.add(id);
    setDismissed(next);
    sessionStorage.setItem("dismissedAnnouncements", JSON.stringify(Array.from(next)));
  };

  const visible = announcements.filter((a) => !dismissed.has(a.id));
  if (visible.length === 0) return null;

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1.5 }}>
      {visible.map((a) => (
        <Box
          key={a.id}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            p: 2,
            borderRadius: 2,
            backgroundColor: "rgba(255,255,255,0.85)",
            borderLeft: "4px solid #ec7777",
            backdropFilter: "blur(8px)",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" fontWeight="bold">{a.title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, whiteSpace: "pre-line" }}>
              {a.body}
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => handleDismiss(a.id)} sx={{ mt: -0.5 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
}
